module.exports = __webpack_public_path__ + "img/pivoine_coral_charme.c5e8c9c7.jpg";